import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import config from '../config';
import LoadingSpinner from '../components/LoadingSpinner';
import Notification from '../components/Notification';
import '../styles/verify-password.css'; // Reuse the same CSS file
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const SetPassword = () => {
    const { userId } = useParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState({ message: '', type: 'success', header: '' });
    const [passwordError, setPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');
    const navigate = useNavigate();

    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
        return passwordRegex.test(password);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'password') {
            if (!validatePassword(value)) {
                setPasswordError('Min 6 caractères avec lettres et chiffres');
            } else {
                setPasswordError('');
            }
            setPassword(value);
        }

        if (name === 'confirmPassword') {
            if (value && password !== value) {
                setConfirmPasswordError('Les mots de passe ne correspondent pas.');
            } else {
                setConfirmPasswordError('');
            }
            setConfirmPassword(value);
        }
    };

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setNotification({ message: 'Les mots de passe ne correspondent pas.', type: 'error', header: 'Erreur' });
            return;
        }

        if (!validatePassword(password)) {
            setNotification({ message: 'Min 6 caractères avec lettres et chiffres', type: 'error', header: 'Erreur' });
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(`${config.backendUrl}/users/reset-password/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ user_id: userId, password: password }),
            });

            if (response.ok) {
                setNotification({ message: 'Mot de passe réinitialisé avec succès.', type: 'success', header: 'Succès' });
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            } else {
                const data = await response.json();
                setNotification({ message: data.message || 'Échec de la réinitialisation du mot de passe.', type: 'error', header: 'Erreur' });
            }
        } catch (error) {
            setNotification({ message: 'Une erreur est survenue. Veuillez réessayer.', type: 'error', header: 'Erreur' });
        } finally {
            setLoading(false);
        }
    };

    const isFormValid = () => {
        return (
            password &&
            confirmPassword &&
            !passwordError &&
            !confirmPasswordError
        );
    };

    return (
        <div className="verify-container">
            {loading && <LoadingSpinner />}
            <Notification
                message={notification.message}
                type={notification.type}
                header={notification.header}
                onClose={() => setNotification({ message: '', type: 'success', header: '' })}
            />
            <div className="verify-card">
                <h2 className="verify-title">Réinitialiser le mot de passe</h2>
                <form className="verify-form" onSubmit={handleSubmit}>
                    <div className="forgot-inputs">
                        <div className={`forgot-input-container ${passwordError ? 'forgot-input-error' : ''} ${!passwordError && password ? 'forgot-input-valid' : ''}`}>
                            <FontAwesomeIcon icon={faLock} className={`forgot-icon ${passwordError ? 'forgot-icon-error' : ''} ${!passwordError && password ? 'forgot-icon-valid' : ''}`} />
                            <input
                                type={passwordVisible ? 'text' : 'password'}
                                name="password"
                                value={password}
                                onChange={handleChange}
                                required
                                placeholder="Nouveau mot de passe"
                                className="forgot-input"
                            />
                            <FontAwesomeIcon
                                icon={passwordVisible ? faEyeSlash : faEye}
                                className="forgot-icon-eye"
                                onClick={togglePasswordVisibility}
                            />
                        </div>
                        {passwordError && <p className="forgot-error-message">{passwordError}</p>}
                        {!passwordError && password && <p className="password-rule">Min 6 caractères avec lettres et chiffres</p>}

                        <div className={`forgot-input-container ${confirmPasswordError ? 'forgot-input-error' : ''} ${!confirmPasswordError && confirmPassword ? 'forgot-input-valid' : ''}`}>
                            <FontAwesomeIcon icon={faLock} className={`forgot-icon ${confirmPasswordError ? 'forgot-icon-error' : ''} ${!confirmPasswordError && confirmPassword ? 'forgot-icon-valid' : ''}`} />
                            <input
                                type={confirmPasswordVisible ? 'text' : 'password'}
                                name="confirmPassword"
                                value={confirmPassword}
                                onChange={handleChange}
                                required
                                placeholder="Confirmer le mot de passe"
                                className="forgot-input"
                            />
                            <FontAwesomeIcon
                                icon={confirmPasswordVisible ? faEyeSlash : faEye}
                                className="forgot-icon-eye"
                                onClick={toggleConfirmPasswordVisibility}
                            />
                        </div>
                        {confirmPasswordError && <p className="forgot-error-message">{confirmPasswordError}</p>}
                    </div>
                    <button
                        type="submit"
                        className="verify-submit"
                        disabled={loading || !isFormValid()}
                    >
                        Réinitialiser
                    </button>
                </form>
            </div>
        </div>
    );
};

export default SetPassword;